module.exports = __webpack_public_path__ + "assets/img/shingles-2.12574288.jpg";